import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// ---------------------------------------------------------

import Icon from '@components/icon';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const { note, note_mast, action, deleting_note } = styles;

// ---------------------------------------------------------

const Note = (props) => {
  let { lastSavedOn, content, showActions, noteId, removeNote } = props;

  const [deletingNote, setDeletingNote] = useState(false);

  const classes = classNames(note, {
    [deleting_note]: deletingNote
  });
  const notemast = classNames(note_mast);
  const action_class = classNames(action);

  const onNoteTrash = (noteId) => {
    setDeletingNote(true);
    removeNote(noteId);
  };

  return (
    <div className={classes}>
      <div className={notemast}>
        <div>
          {lastSavedOn && (
            <label>
              {new Date(lastSavedOn).toLocaleDateString(undefined, {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              })}
              {deletingNote && <span>Deleting note...</span>}
            </label>
          )}
          {content && <p>{content}</p>}
        </div>
        {showActions && (
          <button className={action_class} onClick={() => onNoteTrash(noteId)}>
            <Icon type="actions" name="trash" />
          </button>
        )}
      </div>
    </div>
  );
};

Note.propTypes = {
  content: PropTypes.string, // refers to "note" in backend API
  createdOn: PropTypes.string,
  lastSavedOn: PropTypes.string,
  listingId: PropTypes.number,
  noteId: PropTypes.number,
  removeNote: PropTypes.func,
  showActions: PropTypes.bool
};

export default Note;
